module.exports = __webpack_public_path__ + "img/experience.408e4471.png";